import { render } from "./BreadCrumbsTemplate.vue?vue&type=template&id=607cb6fb"
import script from "./BreadCrumbsTemplate.vue?vue&type=script&lang=js"
export * from "./BreadCrumbsTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__